import { create } from "zustand";

type PreventPageLeaveStore = {
  isPreventing: boolean;
  setPreventing: (value: boolean) => void;
};

export const usePreventPageLeaveStore = create<PreventPageLeaveStore>((set) => ({
  isPreventing: false,
  setPreventing: (value) => set({ isPreventing: value })
}));

export default usePreventPageLeaveStore;
